/**
 * TODO: Need to refactor.
 * This file is copied from `src/pages/courses/components/forum/useRating.js`.
 */
import { useDispatch, useSelector } from 'react-redux';

import { getUserId } from '@src/store/selectors/user';
import {
	getCourseRatingState, getAddCourseRatingState, getCourseRatings, getPropagandaReview,
} from '@src/store/selectors/course';
import { addCourseRatingCall, editCourseRatingCall } from '@src/store/actions/course';
import { IReview, IPropagandaReview } from '@src/types/course';
import { TSideEffectState } from '@src/types/common';

interface IRating {
	courseId: string;
	onlyMe: boolean;
}

interface IUseRating {
	userId: string | null;
	courseRatings: IReview[];
	propagandaReview: IPropagandaReview[];
	courseRatingState: TSideEffectState | undefined;
	addCourseRatingState: TSideEffectState | undefined;
	handleAddCourseRating: (message: string, star: number) => void;
	handleEditCourseRating: (message: string, star: number) => void;
}

const useRating = ({ courseId, onlyMe = false }: IRating): IUseRating => {
	const dispatch = useDispatch();
	const userId = useSelector(getUserId) as string | null;
	const courseRatingState = useSelector(getCourseRatingState(courseId));
	const addCourseRatingState = useSelector(getAddCourseRatingState(courseId));
	const propagandaReview = useSelector(getPropagandaReview(courseId));
	let courseRatings = useSelector(getCourseRatings);

	if (onlyMe) {
		courseRatings = courseRatings.filter(rating => rating.user.id === userId);
	}

	const handleAddCourseRating = (message, star) => {
		dispatch(
			addCourseRatingCall({
				course_id: courseId,
				data: {
					message,
					star,
				},
			}),
		);
	};

	const handleEditCourseRating = (message, star) => {
		dispatch(
			editCourseRatingCall({
				course_id: courseId,
				data: {
					message,
					star,
				},
			}),
		);
	};

	return {
		userId,
		courseRatingState,
		addCourseRatingState,
		courseRatings,
		propagandaReview,
		handleAddCourseRating,
		handleEditCourseRating,
	};
};

export default useRating;
